// extracted by mini-css-extract-plugin
module.exports = {"container":"video-player_container__3EEEj"};